const VersionURL = (url: string) => {
    return `${url}?v=${process.env.REACT_APP_API_VERSION}`;
}

export default VersionURL;

export const VersionURLParam = () => { return `v=${process.env.REACT_APP_API_VERSION}` };

